import React from 'react';
import { Dropdown as AntDropdown } from 'antd';

interface DropdownButtonProps<ItemKey> {
  children: React.ReactNode;
  items: Item<ItemKey>[];
}

type Item<ItemKey> = PlainItem<ItemKey> | GroupItem<ItemKey> | ParentItem<ItemKey> | DividerItem;

interface DividerItem {
  type: 'divider';
  visible?: never;
}

interface PlainItem<ItemKey> {
  label: string | React.ReactNode;
  icon?: React.ReactNode;
  visible?: boolean;
  disabled?: boolean;
  key: ItemKey;
  onClick: () => void;
}

interface ParentItem<ItemKey> {
  label: string | React.ReactNode;
  icon?: React.ReactNode;
  visible?: boolean;
  disabled?: boolean;
  key: ItemKey | string;
  children?: Item<ItemKey>[];
}

interface GroupItem<ItemKey> {
  type: 'group';
  icon?: React.ReactNode;
  visible?: boolean;
  disabled?: boolean;
  label: string;
  key: ItemKey;
  children: Item<ItemKey>[];
}

function DropdownButton<ItemKey extends string>({ children, items }: DropdownButtonProps<ItemKey>) {
  const filterVisibleItems = (items: Item<ItemKey>[]): Item<ItemKey>[] => {
    return items.reduce((result, item) => {
      if ('visible' in item && item.visible === false) {
        return result;
      } else if ('children' in item) {
        const filteredChildren = filterVisibleItems(item.children as Item<ItemKey>[]);
        delete item.visible;
        if (filteredChildren.length > 0) {
          result.push({ ...item, children: filteredChildren });
        }
      } else {
        delete item.visible;
        result.push(item);
      }
      return result;
    }, [] as Item<ItemKey>[]);
  };

  return (
    <AntDropdown menu={{ items: filterVisibleItems(items) }} trigger={['click']}>
      {children}
    </AntDropdown>
  );
}

export { DropdownButton };
